import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';

const categoryIndexJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BreadcrumbList",
      "@id": "https://51chigua.com/category/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "首页",
          "item": "https://51chigua.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "全部分类"
        }
      ]
    },
    {
      "@type": "CollectionPage",
      "@id": "https://51chigua.com/category/#webpage",
      "url": "https://51chigua.com/category",
      "name": "全部分类 - 51吃瓜App",
      "description": "浏览所有分类，发现你感兴趣的吃瓜内容。覆盖明星爆料、网红吃瓜、社会热点、每日大赛、51吃瓜视频等热门分类。",
      "isPartOf": {
        "@type": "WebSite",
        "@id": "https://51chigua.com/#website"
      },
      "inLanguage": "zh-CN"
    }
  ]
};

export default function CategoryIndex() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categoryIndexJsonLd) }}
      />
      <Navbar />
      <main className="pt-20 pb-10">
        <nav className="px-4 md:px-6 py-4 max-w-7xl mx-auto" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-900 font-medium">全部分类</li>
          </ol>
        </nav>

        <section className="px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900 mb-2">
              全部分类
            </h1>
            <p className="text-foreground-600 text-sm md:text-base mb-10">
              浏览所有分类，发现你感兴趣的吃瓜内容
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col gap-4 p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 text-primary-600 rounded-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {cat.name}
                    </h3>
                    <p className="mt-1.5 text-foreground-600 text-sm leading-relaxed">
                      {cat.description}
                    </p>
                    <p className="mt-3 text-foreground-500 text-xs">
                      共 {cat.articleCount} 篇文章
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}